import { render, staticRenderFns } from "./detailPopup.vue?vue&type=template&id=241adf5a"
import script from "./detailPopup.vue?vue&type=script&lang=js"
export * from "./detailPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports